module.exports = __webpack_public_path__ + "img/icon_05@2x.c06dd688.gif";